import { SelectField, StandardDialog } from "@roc/ui";
import { observer } from "mobx-react";
import { QuoteTypeStore } from "../../../stores/quoteTypeStore";
import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

export const feesOptions = [
  {
    label: 'Commitment',
    value: 'Commitment',
  },
  {
    label: 'Valuation',
    value: 'Valuation',
  },
  {
    label: 'Application',
    value: 'Application',
  },
  {
    label: 'Processing',
    value: 'Processing',
  },
];

const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: "20px"
  },
  includesList: {
    marginLeft: '25px'
  },
  note: {
    marginLeft: "35px"
  },
  secondHeaderText: {
    fontWeight: 'bold'
  },
  container: {
    border: '1px solid #c4c4c4',
    borderRadius: '15px',
    minWidth: '100%',
    margin: '20px 0px 20px 0px'
  },
  boxItem1: {
    margin: '30px 30px 10px 30px',
  },
  boxItem2: {
    margin: '0px 30px 10px 30px',
  },
  boxItem3: {
    margin: '30px'
  },
  feeAmount: {
    border: '1px solid #ffedbf',
    backgroundColor: '#ffedbf',
    borderRadius: '10px',
    margin: '0px 30px 10px 30px'
  },
  feeAmountTextEnd: {
    margin: '10px 10px 10px 0px',
  },
  feeAmountTextStart: {
    margin: '10px 0px 10px 10px',
  },
  button: {
    width: '100px',
    marginBottom: '20px'
  }
}));

interface InternalValuationPilotDialogProps {
  store: QuoteTypeStore
}

const InternalValuationDialogContent = observer(({ store
}: InternalValuationPilotDialogProps) => {
  const classes = useStyles();

  const saveFeeName = () => {
    store.internalValuationPilotDialogOpen = false;
    store.globalStore.notificationStore.showSuccessNotification({
      message: 'Internal valuation fee selected and saved!',
    });
    if (!store.isEditingLoan) {
      store.saveQuote()
    }
  }

  return (
    <Grid container xs={12} style={{ overflow: 'hidden' }}>
      <Grid item xs={12} className={classes.header}>
        <Typography variant="body2">
          Thank you for selecting our in-house valuation, RealVal. Please note this fee replaces the appraisal fee that you would normally find on a loan and it does not impact your commission
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" className={classes.secondHeaderText}>
          RealVal requires photos of the interior of the property taken with an inspection app. Please be aware that the fee, SOW, and property photos are required before the in-house valuation process can begin.
        </Typography>
      </Grid>
      <Grid item container xs={12} >
        <Box className={classes.container}>
          <Grid item xs={12} className={classes.boxItem1}>
            <Alert severity="info" variant="outlined">You can change the name of this fee if you'd like.</Alert>
          </Grid>
          <Grid item xs={12} className={classes.boxItem2}>
            <SelectField
              label={'Fee'}
              value={store.internalValuationPilotFeeName}
              options={feesOptions}
              onChange={value => store.internalValuationPilotFeeName = value}
              variant={'outlined'}
              fullWidth
              testId={'feeOptions'}
              placeholder={'Fee'}
            />
          </Grid>
          <Box className={classes.feeAmount}>
            <Grid container xs={12} direction="row">
              <Grid item container xs={6} justifyContent="flex-start">
                <Typography variant="h6" className={classes.feeAmountTextStart}>
                  Total Fee
                </Typography>
              </Grid>
              <Grid item container xs={6} justifyContent="flex-end">
                <Typography variant="h6" className={classes.feeAmountTextEnd}>
                  $500.00
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Grid item xs={12} className={classes.boxItem3}>
            <Alert severity="error" variant="outlined">Please note that this fee is non-refundable.</Alert>
          </Grid>
        </Box>
        <Grid item container xs={12} justifyContent="center" alignItems="center">
          <Button variant='outlined' className={classes.button} color='primary' onClick={() => saveFeeName()}>
            SAVE
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
})

export const InternalValuationPilotDialog = observer(({
  store
}: InternalValuationPilotDialogProps) => {
  return (
    <StandardDialog
      open={store.internalValuationPilotDialogOpen}
      handleClose={() => { store.internalValuationPilotDialogOpen = false }}
      title={'RealVal Fee'}
      dialogContent={<InternalValuationDialogContent store={store} />}
      removeContentBox={true}
    />
  )
})